import createUpdateFilesEvents from '/src/lib/custom/js/createupdatefilejson.js';

const browseFileEvents = (function () {
  let browseFileData = null;
  let browseSelectedFile = null;
  let browseSelectedPath = null;
  let browseSortOrder = { fileName: 'asc', lastUpdated: 'asc' };
  let isCurrentFileDeleted = false;
  let urlFileName = '';
  let vendor = null;
  let folderUUID = null;
  let eventListeners = []; // Tracks all event listeners

  const addListener = (selector, event, delegatedSelector, handler) => {
    if (delegatedSelector) {
      $(selector).on(event, delegatedSelector, handler); // Handle delegated events
    } else {
      $(selector).on(event, handler); // Handle direct binding
    }
    eventListeners.push({ selector, event, delegatedSelector, handler });
  };


  const removeListener = (selector, event, handler) => {
    $(selector).off(event, handler);
    eventListeners = eventListeners.filter(
      listener => !(listener.selector === selector && listener.event === event && listener.handler === handler)
    );
  };

  const removeAllChildrenRecursively = (selector) => {
    $(selector).each(function () {
      const container = $(this);

      // Define and call a recursive function to clean up all children
      (function removeChildren(element) {
        while (element.children().length > 0) {
          element.children().each(function () {
            removeChildren($(this)); // Recursive call for nested children
            $(this).remove(); // Remove the child itself
          });
        }
      })(container);
    });
  };


  const loadFiles = () => {
    const storageKey = 'browse_files'
    $('#browse-loadingSpinner').show();
    removeAllChildrenRecursively('#browse-fileTableBody');
    removeAllChildrenRecursively('#browse-fileCards');

    toggleDesktopButtons(false);

    // Check if data exists in localStorage
    const cachedData = localStorage.getItem(storageKey);
    if (cachedData) {
      const parsedData = JSON.parse(cachedData);
      browseFileData = parsedData;
      browsePopulateTable(parsedData);
    }else{
      $('#browse-loadingSpinner').hide();
      updateFileCountDisplay(0,0);
    }
  };


  const browsePopulateTable = (filteredData = browseFileData) => {
    const totalFiles = browseFileData.length;
    const displayedFiles = filteredData.length;

    const refreshed = getCookie('refreshed');
    if (refreshed) {
      if ($('#browse-refreshBtn')) $('#browse-refreshBtn').hide();
      if ($('#mobile-browse-refreshBtn')) $('#mobile-browse-refreshBtn').hide();
    } else {
      if ($('#browse-refreshBtn')) $('#browse-refreshBtn').show();
      if ($('#mobile-browse-refreshBtn')) $('#mobile-browse-refreshBtn').show();
    }

    // Update the number of files display
    updateFileCountDisplay(displayedFiles, totalFiles);
    $('#browse-fileTableBody').empty();
    $('#browse-fileCards').empty();

    toggleDesktopButtons(filteredData.length > 0);

    filteredData.forEach((file) => {
      const isLongDescription = (file) => {
        if (!file || !file.inflatedDescription) {
          console.error("Invalid file or missing inflatedDescription.");
          return false;
        }

        const shortDescriptionLength = file.shortDescription ? file.shortDescription.length : 45;
        return file.inflatedDescription.length > shortDescriptionLength;
      };

      let fullDescString = '';

      try {
        const parsed = typeof file.inflatedDescription === 'string'
          ? JSON.parse(file.inflatedDescription)
          : file.inflatedDescription;

        fullDescString = parsed?.jd || '';
      } catch (e) {
        fullDescString = typeof file.inflatedDescription === 'string'
          ? file.inflatedDescription
          : '';
      }

      // Escape only double quotes for HTML attribute
      const escapedDesc = fullDescString.replace(/"/g, '&quot;');

      //console.log ("File metaDataLink is: ", file.metadatafilelink);




      $('#browse-fileTableBody').append(`
          <tr class="browse-table-row">
            <td class="browse-table-cell"><input type="checkbox" class="browse-rowCheckbox custom-checkbox"></td>
            <td class="browse-table-cell"><a href="${file.filePath}" class="browse-file-link" data-path="${file.filePath}" data-filename="${file.fileName}" data-metadatafilelink="${file.metadatafilelink}" onclick="handleNavigation(event, '${file.filePath}');">${file.fileName}</a></td>
            <td class="browse-table-cell">${file.type}</td>
            <td class="browse-table-cell">${new Date(file.lastUpdated).toLocaleString()}</td>
            <td class="browse-table-cell">
              <span class="browse-hover-description">${file.shortDescription}</span>
              ${isLongDescription ? `
                <span class="browse-description-icon" data-full-description="${escapedDesc}">
                  <svg width="16" height="16" style="vertical-align: sub; cursor: pointer;">
                    <use href="#icon-info"></use>
                  </svg>
                </span>` : ''}
            </td>
          </tr>
        `);

      $('#browse-fileCards').append(`
          <div class="browse-file-card">
            <h3><a href="${file.filePath}" class="browse-file-link" data-path="${file.filePath}"  data-filename="${file.fileName}" data-metadatafilelink="${file.metadatafilelink}">${file.fileName}</a></h3>
            <div><strong>${getI18n('type')}:</strong> ${file.type}</div>
            <div><strong>${getI18n('last_modified')}</strong> ${new Date(file.lastUpdated).toLocaleString()}</div>
            <div><strong>${getI18n('description')}</strong>
              <span class="browse-hover-description">${file.shortDescription}</span>
              ${isLongDescription ? `
                <span class="browse-description-icon" data-full-description="${escapedDesc}">
                  <svg width="16" height="16" style="vertical-align: sub; cursor: pointer;">
                    <use href="#icon-info"></use>
                  </svg>
                </span>` : ''}
            </div>
            <div class="browse-card-actions">
              <button class="button-primary browse-rename-file" data-filename="${file.fileName}" data-path="${file.filePath}" data-metadatafilelink="${file.metadatafilelink}">${getI18n('rename')}</button>
              <button class="button-primary browse-delete-file" data-filename="${file.fileName}" data-path="${file.filePath}" data-metadatafilelink="${file.metadatafilelink}">${getI18n('delete')}</button>
            </div>
          </div>
        `);
    });

    removeListener('.browse-description-icon', 'click', browseDescriptionHandler);
    addListener('.browse-description-icon', 'click', browseDescriptionHandler);

    $('#browse-loadingSpinner').hide();
  };

  const browseSortTable = (sortKey) => {
    if (!browseSortOrder[sortKey]) {
      browseSortOrder[sortKey] = 'asc';
    } else if (browseSortOrder[sortKey] === 'asc') {
      browseSortOrder[sortKey] = 'desc';
    } else {
      delete browseSortOrder[sortKey];
    }

    const order = browseSortOrder[sortKey];
    if (order) {
      browseFileData.sort((a, b) => {
        let aValue = a[sortKey];
        let bValue = b[sortKey];
        if (sortKey === 'lastUpdated') {
          aValue = new Date(a[sortKey]);
          bValue = new Date(b[sortKey]);
        }
        return aValue < bValue ? (order === 'asc' ? -1 : 1) : (aValue > bValue ? (order === 'asc' ? 1 : -1) : 0);
      });
    } else {
      browseFileData.sort((a, b) => browseFileData.indexOf(a) - browseFileData.indexOf(b));
    }
    browsePopulateTable(browseFileData);
  };

  const browseDescriptionHandler = function (event) {
    console.log('clicked on browse description icon-info');
    const description = $(this).data('full-description');
    const tooltip = $('#browse-customTooltip');
    const tooltipContent = tooltip.find('.browse-tooltip-content');

    if (tooltip.is(':visible') && tooltipContent.text() === description) {
      tooltip.fadeOut(200);
    } else {
      tooltipContent.text(description);

      // Calculate initial position
      const initialLeft = $(this).offset().left - 250;
      const viewportWidth = $(window).width();

      // Adjust left position if it would go out of bounds
      const adjustedLeft = Math.max(10, Math.min(initialLeft, viewportWidth - tooltip.outerWidth() - 10));

      tooltip.css({
        top: $(this).offset().top + $(this).outerHeight() + 5,
        left: adjustedLeft
      }).fadeIn(200);
    }

    event.stopPropagation();
  };


  const bindEvents = () => {

    $('#browse-submitRename').prop('disabled', true);

    $('#browse-newFileName').on('input', function () {

      const newName = $(this).val().trim();
      const errorMessage = $('#rename-filename-error');

      // Check if the new name is different from the original name
      const isSameAsOriginal = newName === browseSelectedFile;

      // Check if filename already exists in browseFileData
      const isNameTaken = browseFileData && browseFileData.some(file => {
        return file.fileName === newName;
      });

      // Check if filename contains a dot
      const hasDot = newName.includes('.');

      // Validation logic with appropriate error messages
      if (isSameAsOriginal || newName === '') {
        errorMessage.text(getI18n('enter_unique_filename')).show();
        $('#browse-submitRename').prop('disabled', true);
      } else if (isNameTaken) {
        errorMessage.text(getI18n('filename_exists')).show();
        $('#browse-submitRename').prop('disabled', true);
      } else if (hasDot) {
        errorMessage.text(getI18n('filename_no_dot')).show();
        $('#browse-submitRename').prop('disabled', true);
      } else {
        // If all checks pass, hide the error message and enable the submit button
        errorMessage.hide();
        $('#browse-submitRename').prop('disabled', false);
      }
    });


    addListener('#browse-filterInput', 'input', function () {
      const filter = $(this).val().toLowerCase();
      const filteredData = browseFileData.filter(file => file.fileName.toLowerCase().includes(filter) || file.inflatedDescription.toLowerCase().includes(filter));
      browsePopulateTable(filteredData);
    });

    addListener('#browse-selectAll', 'click', function () {
      const isChecked = $(this).prop('checked');
      $('.browse-rowCheckbox').prop('checked', isChecked);
    });

    addListener('th.browse-sortable', 'click', function () {
      browseSortTable($(this).data('sort'));
    });

    addListener('#browse-fileTableBody, #browse-fileCards', 'click', '.browse-file-link', function (e) {
      e.preventDefault();
      const filePath = $(this).data('path');
      window.open(filePath, '_blank');
    });

    //for Mobile
    addListener('#browse-fileCards', 'click', '.browse-rename-file', function () {
      browseSelectedFile = $(this).data('filename');
      browseSelectedPath = $(this).data('path');
      $('#browse-newFileName').val(browseSelectedFile);
      $('#browse-renameDialog').show();
    });


    addListener('#browse-closeRenameDialog, #browse-cancelRename', 'click', () => {
      $('#browse-renameDialog').hide();
    });

    addListener('#browse-openBtn', 'click', function () {
      const selectedFilePath = $('.browse-rowCheckbox:checked').closest('tr').find('.browse-file-link').data('path');
      if (selectedFilePath) {
        window.open(selectedFilePath, '_blank');
      } else {
        Swal.fire({
          title: getI18n('alert'),
          text: getI18n('select_one_file_to_open'),
          icon: "info",
          timer: 3000
        });
      }
    });

    //For desktop
    addListener('#browse-renameBtn', 'click', function () {
      const selectedRow = $('.browse-rowCheckbox:checked').closest('tr');
      if (selectedRow.length === 1) {
        browseSelectedFile = selectedRow.find('.browse-file-link').data('filename');
        browseSelectedPath = selectedRow.find('.browse-file-link').data('path');
        $('#renameFileDialogHeading').text(getI18n('rename_file'));
        $('#browse-newFileName').val(browseSelectedFile);
        $('#browse-renameDialog').show();
      } else {
        Swal.fire({
          title: getI18n('alert'),
          text: getI18n('select_one_file_to_rename'),
          icon: "info",
          timer: 3000
        });
      }
    });

    addListener('#browse-submitRename', 'click', function (e) {
      e.stopImmediatePropagation();
      e.stopPropagation();

      const newName = $('#browse-newFileName').val();
      const newPath = browseSelectedPath.replace(browseSelectedFile, newName);

      if (newName && browseSelectedFile) {
        // Prepare request data for the API
        const requestData = {
          vendor: vendor,
          folderUUID: folderUUID,
          currentFileName: browseSelectedFile,
          newFileName: newName
        };

        // Call the rename API
        $.ajax({
          url: getApiUrl('renameObject', 'loginapi'),
          method: 'POST',
          contentType: 'application/json',
          data: JSON.stringify(requestData),
          success: function (response) {
            // Show success message
            Swal.fire({
              title: getI18n('success'),
              text: getI18n('file_renamed_successfully'),
              icon: "success",
            }).then(() => {
              // Close rename dialog
              $('#browse-renameDialog').hide();

              // Update local storage using createUpdateFilesEvents
              createUpdateFilesEvents.updateFile(browseSelectedFile, {
                fileName: newName,
                lastUpdated: new Date().toISOString(),
                filePath: newPath
              });

              // Update resumeUrl in localStorage if it contains the old filename
              let resumeUrl = getLocalStorageItem(`resumeUrl-${folderUUID}`);
              if (resumeUrl && resumeUrl.endsWith(`${browseSelectedFile}.html`)) {
                // Replace old filename with new filename in the URL
                resumeUrl = resumeUrl.replace(`${browseSelectedFile}.html`, `${newName}.html`);
                setLocalStorageItem(`resumeUrl-${folderUUID}`, resumeUrl);
              }

              // Refresh table with updated data
              refreshFileTable();
            });
          },
          error: function (error) {
            // Show error message with Swal
            Swal.fire({
              title: getI18n('oops_something_wrong'),
              html: getI18n('error_while_renaming_file'),
              icon: "error",
            });
            console.error(getI18n('error_while_renaming_file'), error);
          }
        });
      } else {
        Swal.fire({
          title: getI18n('alert'),
          text: getI18n('invalid_filename_or_selection'),
          icon: "warning",
        });
      }
    });


    //For Mobile
    // New Event handler for delete button on individual mobile cards
    addListener('#browse-fileCards', 'click', '.browse-delete-file', function () {
      const fileToDelete = {
        path: $(this).data('path'),
        filename: $(this).data('filename'),
        metadatafilelink: $(this).data('metadatafilelink')
      };

      const messageTemplate = getI18n('confirm_delete_single_file', { filename: fileToDelete.filename });

      // Replace placeholder in the message template with the filename
      const message = messageTemplate.replace('{filename}', fileToDelete.filename);

      // Confirm deletion for individual mobile file
      Swal.fire({
        title: getI18n('warning'),
        text: message,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: getI18n('confirm'),
        cancelButtonText: getI18n('cancel')
      }).then((result) => {
        if (result.isConfirmed) {
          // Call the delete API for the single file
          $.ajax({
            url: getApiUrl('deleteObjects', 'loginapi'),
            method: 'POST',
            contentType: 'application/json',
            data: JSON.stringify({ vendor: vendor, folderUUID: folderUUID, files: [fileToDelete] }),
            success: function (response) {
              // Show success message
              Swal.fire({
                title: getI18n('success'),
                text: getI18n('file_deleted_successfully', { filename: fileToDelete.filename }), // Assuming this is added to i18n
                icon: "success",
              }).then(() => {
                if (urlFileName && fileToDelete.filename === urlFileName) {
                  isCurrentFileDeleted = true; // Set flag to true if the current file is deleted
                }
                // Remove file from local storage and update display
                createUpdateFilesEvents.deleteFile(fileToDelete.filename);
                refreshFileTable(); // Refresh table with updated data
              });
            },
            error: function (error) {
              // Show error message with Swal
              Swal.fire({
                title: getI18n('oops_something_wrong'),
                text: getI18n('error_while_deleting'),
                icon: "error",
              });
            }
          });
        }
      });
    });



    //For desktop
    // Event handler for delete button
    addListener('#browse-deleteBtn', 'click', function () {
      const selectedFiles = $('.browse-rowCheckbox:checked').closest('tr').find('.browse-file-link').map(function () {
        return {
          path: $(this).data('path'),
          filename: $(this).data('filename'),
          metadatafilelink: $(this).data('metadatafilelink')
        };
      }).get();

      if (selectedFiles.length > 0) {
        // Populate delete modal with file names
        const deleteFileList = $('#browse-deleteDialog .delete-file-list');
        deleteFileList.empty();
        selectedFiles.forEach(file => {
          deleteFileList.append(`<p>${file.filename}</p>`);
        });

        // Show delete dialog
        $('#browse-deleteDialog').show();

        // Handle submit delete
        $('#browse-submitDelete').off('click').click(function () {
          // Prepare data for delete API call
          const filesToDelete = selectedFiles.map(file => ({ path: file.path, filename: file.filename, metadatafilelink: file.metadatafilelink }));
          console.log ('delete files', JSON.stringify({ vendor: vendor, folderUUID: folderUUID, files: filesToDelete }));

          // Call the delete API
          $.ajax({
            url: getApiUrl('deleteObjects', 'loginapi'),
            method: 'POST',
            contentType: 'application/json',
            data: JSON.stringify({ vendor: vendor, folderUUID: folderUUID, files: filesToDelete }),
            success: function (response) {
              // Show success message
              Swal.fire({
                title: getI18n('success'),
                text: getI18n('files_deleted_successfully'),
                icon: "success",
              }).then(() => {
                // Close delete dialog
                $('#browse-deleteDialog').hide();
                filesToDelete.forEach(file => {
                  if (urlFileName && file.filename === urlFileName) {
                    isCurrentFileDeleted = true; // Set flag to true if the current file is deleted
                  }
                  createUpdateFilesEvents.deleteFile(file.filename);
                  workerInitializationEvents.getContentWorker().postMessage({
                    id: getMessageId(),
                    action: 'deleteContent',  // Delete content from IndexedDB
                    data: { filename: file.filename }
                  });
                });

                // Refresh table with updated data
                refreshFileTable();
              });
            },
            error: function (error) {
              // Show error message with Swal
              Swal.fire({
                title: getI18n('oops_something_wrong'),
                text: getI18n('error_while_deleting'),
                icon: "error",
              });
              console.error(getI18n('error_while_deleting'), error);
            }
          });
        });

        // Handle cancel button to close modal
        addListener('#browse-cancelDelete', 'click', () => $('#browse-deleteDialog').hide());
      } else {
        Swal.fire({
          title: getI18n('alert'),
          text: getI18n('select_files_to_delete'),
          icon: "info",
          timer: 3000
        });
      }
    });

    $('#browse-closeModal').click(function () {
      $('#browse-fileModal').hide();
      resetData();
      unbindEvents();
      unload();
      console.log('isCurrentFileDeleted', isCurrentFileDeleted);
      if (isCurrentFileDeleted) {
        isCurrentFileDeleted = false;
        navigate('/');
      }
    });





    addListener('#browse-customTooltip', 'click', function (event) {
      event.stopPropagation();
    });

    $(document).click(function () {
      $('#browse-customTooltip').fadeOut(200);
    });
  };

  function adjustTooltipPosition(tooltip) {
    const viewportWidth = $(window).width();
    const viewportHeight = $(window).height();
    const tooltipOffset = tooltip.offset();
    const tooltipWidth = tooltip.outerWidth();
    const tooltipHeight = tooltip.outerHeight();

    if (tooltipOffset.left + tooltipWidth > viewportWidth) {
      tooltip.css('left', viewportWidth - tooltipWidth - 10);
    }
    if (tooltipOffset.top + tooltipHeight > viewportHeight) {
      tooltip.css('top', viewportHeight - tooltipHeight - 10);
    }
  }

  // Function to refresh the table from local storage data
  function refreshFileTable() {
    const updatedData = createUpdateFilesEvents.getData();
    browseFileData = updatedData;
    browsePopulateTable(browseFileData);
  }

  const unbindEvents = () => {
    // Unbind table and card view events
    $('#browse-filterInput').off('input');
    $('th.browse-sortable').off('click');
    $('#browse-selectAll').off('click');
    $('#browse-fileTableBody, #browse-fileCards').off('click', '.browse-file-link');
    $('#browse-fileCards').off('click', '.browse-rename-file');
    $('#browse-fileCards').off('click', '.browse-delete-file');

    // Unbind modal-related events
    $('#browse-submitRename').off('click');
    $('#browse-refreshBtn').off('click');
    $('#browse-closeRenameDialog, #browse-cancelRename').off('click');
    $('#browse-openBtn').off('click');
    $('#browse-renameBtn').off('click');
    $('#browse-submitRename').off('click');
    $('#browse-deleteBtn').off('click');
    $('#browse-cancelDelete').off('click');
    $('#browse-submitDelete').off('click');
    $('#browse-closeModal').off('click');

    // Tooltip and description events
    $(document).off('click', '.browse-description-icon');
    $('#browse-newFileName').off('input'); // Input validation for renaming
    $(document).off('click', '#browse-customTooltip');


    // Ensure any custom tooltips or dynamic elements are cleaned
    $('#browse-customTooltip').off(); // Remove any lingering events from custom tooltips

    // Unbind all events from dynamically created elements if applicable
    $('.browse-rowCheckbox').off('change'); // Unbind checkbox selection if any logic is tied
    $('.browse-delete-file').off('click');  // Unbind delete events for file cards
  };


  // Utility function to toggle button states
  const toggleDesktopButtons = (enable) => {
    $('#browse-openBtn').prop('disabled', !enable);
    $('#browse-deleteBtn').prop('disabled', !enable);
    $('#browse-renameBtn').prop('disabled', !enable);
  };

  const resetData = () => {
    browseFileData = null;
    browseSelectedFile = null;
    browseSortOrder = { fileName: 'asc', lastUpdated: 'asc' };
  };

  const updateFileCountDisplay = (displayedFiles, totalFiles) => {
    const message = getI18n('displaying_files')
      .replace('{number_of_files}', displayedFiles)
      .replace('{total_of_all_files}', totalFiles);

    $('#browse_number_of_files').text(message);
  };


  const init = (initFolderUUID, initVendor) => {
    try {
      // Assign to module-level variables
      vendor = initVendor;
      folderUUID = initFolderUUID;
      urlFileName = window.location.href.split('/').pop().replace('.html', '');
      $('#browse-fileModal').show();
      loadFiles();
      bindEvents();
    } catch (error) {
      console.error('Error during initialization:', error);
    }
  };


  const unload = () => {
    // Unbind all event listeners
    if (eventListeners) {
      eventListeners.forEach(({ selector, event, handler }) => {
        try {
          // console.log(`Removing event listener:
          //   Selector: ${selector},
          //   Event: ${event},
          //   Handler:`, handler);

          $(selector).off(event, handler);
        } catch (error) {
          console.error(`Error while removing event listener for Selector: ${selector}, Event: ${event}`, error);
        }
      });
      eventListeners.length = 0; // Clear the array after removing all listeners
    }

    // Clear dynamically created content
    removeAllChildrenRecursively('#browse-fileTableBody');
    removeAllChildrenRecursively('#browse-fileCards');

    // Reset data
    browseFileData = null;
    browseSelectedFile = null;
    browseSelectedPath = null;
    console.log('Resources cleaned up.');
  };



  return { init, refreshFileTable };
})();

export default browseFileEvents;
